import clsx from 'clsx';
import { MeetingStatus } from '../../types';

interface StatusBadgeProps {
  status: MeetingStatus;
  size?: 'sm' | 'md';
}

const statusConfig = {
  [MeetingStatus.SCHEDULED]: {
    label: 'Agendado',
    className: 'bg-blue-100 text-blue-700 border-blue-200',
  },
  [MeetingStatus.CONFIRMED]: {
    label: 'Confirmado',
    className: 'bg-green-100 text-green-700 border-green-200',
  },
  [MeetingStatus.IN_PROGRESS]: {
    label: 'Em Andamento',
    className: 'bg-purple-100 text-purple-700 border-purple-200',
  },
  [MeetingStatus.COMPLETED]: {
    label: 'Concluído',
    className: 'bg-gray-100 text-gray-700 border-gray-200',
  },
  [MeetingStatus.CANCELED]: {
    label: 'Cancelado',
    className: 'bg-red-100 text-red-700 border-red-200',
  },
  [MeetingStatus.NO_SHOW]: {
    label: 'Ausente',
    className: 'bg-orange-100 text-orange-700 border-orange-200',
  },
};

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const config = statusConfig[status] || statusConfig[MeetingStatus.SCHEDULED];

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium border rounded-full',
        config.className,
        size === 'sm' && 'px-2 py-0.5 text-xs',
        size === 'md' && 'px-3 py-1 text-sm'
      )}
    >
      {config.label}
    </span>
  );
}
